import Component from '../inherited/Component'
import Helpers from '../lib/Helpers' 

export default class ProductSelector extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)

    this._progressSelector = this._elem.querySelector('[data-product-selector-progress]')
    this._progressButtons = this._progressSelector.querySelectorAll('button')
    this._addButtons = this._elem.querySelectorAll('[data-product-selector-button]')
    this._submitButton = this._elem.querySelector('[data-product-selector-submit]')
    this._submitForm = this._elem.querySelector('[data-product-selector-form]')
    this._steps = this._elem.querySelectorAll('[data-product-selector-step]')
    this._productCount = this._elem.querySelector('[data-product-selector-count]')
    this._priceElem = this._elem.querySelector('[data-product-selector-price]')
  }

  mount () {
    for (let [index, button] of this._progressButtons.entries()) {
        button.addEventListener('click', e => {
          e.preventDefault()
          this._steps.forEach(step => {
            if(step == this._steps[index]) {
                step.classList.remove('hide')
            } else {
                step.classList.add('hide')
            }
            this._ctx.emit('radiant--update')
            this._theme.mountComponents(this._elem)
          })
          for (let [buttonIndex, button] of this._progressButtons.entries()) {
            if(buttonIndex < index) {
                button.parentNode.classList.add('completed')
                button.parentNode.classList.add('active')
            } else if(buttonIndex > index) {
                button.parentNode.classList.remove('active')
                button.parentNode.classList.remove('completed')
            } else {
                button.parentNode.classList.add('active')
                button.parentNode.classList.remove('completed')
            }
          }
        })
    }

    for (let [index, button] of this._addButtons.entries()) {
        let currentStep = button.closest('[data-product-selector-step]')
        button.addEventListener('click', e => {
          e.preventDefault()
          let chosenProduct = button.closest('.product-grid-item')
          let chosenRadio = chosenProduct.querySelector('input[type="radio"')
          if(button.dataset.productSelectorButton == 'add') {
            chosenRadio.checked = true
            chosenProduct.classList.add('added')
          } else {
            chosenRadio.checked = false
            chosenProduct.classList.remove('added')
          }

          let otherProducts = Array.from(currentStep.querySelectorAll('.product-grid-item')).filter(product => product !== chosenProduct)
          for (let product of otherProducts) {
            product.classList.remove('added')

            if(product.querySelector('input[type="radio"]')) {
                product.querySelector('input[type="radio"]').checked = false
            }
          }

          let allowAdd = true
          let productCount = 0
          let totalPrice = 0
          for (let step of this._steps) {
            if(!step.querySelector('.product-grid-item.added')) {
                allowAdd = false   
            } else {
                productCount = productCount + 1
                let productPrice = Number(step.querySelector('.product-grid-item.added [data-product-selector-product-price]').dataset.productSelectorProductPrice)
                totalPrice = totalPrice + productPrice
            }
          }

          this._priceElem.innerHTML = Helpers.formatMoney(totalPrice, this._ctx.getState())

          this._productCount.innerHTML = productCount

          if(allowAdd) {
            for(let [index, step] of this._steps.entries()) {
              let variantId = Number(step.querySelector('.product-grid-item.added [data-product-selector-radio]').value)
              
              let input = document.createElement('input')
              input.setAttribute('type', 'hidden')
              input.setAttribute('name', `items[${index}][id]`)
              input.setAttribute('value', variantId)
              this._submitForm.appendChild(input)

              let quantityInput = document.createElement('input')
              quantityInput.setAttribute('type', 'hidden')
              quantityInput.setAttribute('name', `items[${index}][quantity]`)
              quantityInput.setAttribute('value', 1)
              this._submitForm.appendChild(quantityInput)

            }
            this._submitButton.removeAttribute('disabled')
          } else {
            this._submitButton.setAttribute('disabled', 'disabled')
            this._submitForm.querySelectorAll('input').forEach(input => input.remove())
          }

          let currentStepIndex = currentStep.dataset.productSelectorStep
          let nextStepIndex = Number(currentStepIndex) + 1
          let nextStep = this._elem.querySelector(`[data-product-selector-step="${nextStepIndex}"]`)
          if(nextStep) {
            setTimeout(() => {
              
              this._progressSelector.children[currentStepIndex].querySelector('button').click()

              setTimeout(() => {
                this._priceElem.scrollIntoView({ top: 0, behavior: 'smooth' });
              }, 100)

            }, 1000)
          }
        })
    }
  }
}